import { render, staticRenderFns } from "./dataMovieOverview.vue?vue&type=template&id=40a68390&scoped=true"
import script from "./dataMovieOverview.vue?vue&type=script&lang=js"
export * from "./dataMovieOverview.vue?vue&type=script&lang=js"
import style0 from "./dataMovieOverview.vue?vue&type=style&index=0&id=40a68390&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a68390",
  null
  
)

export default component.exports